<script setup>
import { computed } from 'vue'

import { useProgressCell } from '@/utils/element-progress'
import { CHECKIN_ENTITY_KEYS } from '@/utils/entity-keys'
import { getGradeColorStyle, getGradeDisplayValue } from '@/utils/okr-elements/grade'
import { MATH_SYMBOLS } from '@/utils/okr-elements/math'

defineOptions({
  name: 'CheckinChangedProgress'
})

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})

const { displayValue } = useProgressCell({
  data: () => {
    return {
      ...props.data,
      [CHECKIN_ENTITY_KEYS.VALUE]: getGradeDisplayValue(props.data[CHECKIN_ENTITY_KEYS.VALUE]),
      unit: MATH_SYMBOLS.PERCENT
    }
  }
})

const colorStyles = computed(() => {
  if (props.data[CHECKIN_ENTITY_KEYS.OUTDATED]) {
    return {
      color: 'var(--grey-1-next)'
    }
  }

  return getGradeColorStyle(props.data[CHECKIN_ENTITY_KEYS.COLOR])
})

const testId = computed(() => {
  return `${props.data[CHECKIN_ENTITY_KEYS.OUTDATED] ? 'old' : 'new'}-progress`
})
</script>

<template>
  <div
    :class="{
      'cc-Progress-outdated': data[CHECKIN_ENTITY_KEYS.OUTDATED]
    }"
    :data-auto-testid="testId"
    :data-testid="testId"
    :style="{ ...colorStyles }"
    class="cc-Progress"
  >
    {{ displayValue }}
  </div>
</template>

<style lang="scss" scoped>
.cc-Progress {
  font-size: $fs-14;
  line-height: 16px;

  &:not(&-outdated) {
    font-weight: fw('bold');
  }

  &-outdated {
    font-weight: fw('semi-bold');
  }
}
</style>
